import { useActions } from '.';
import { LoggerConsole } from '../devices/logger/impl/LoggerConsole';

export const useLogger = () => {
  const { setLoggerAction } = useActions();
  const setLogger = async () => {
    console.log('set logger');
    const logger = new LoggerConsole();
    setLoggerAction(logger);
  };
  return [setLogger] as const;
};
